import './style.scss';

const openFaq = () => {
    const qElem = document.getElementsByClassName('wp-block-hhb-blocks-faq-block_inner--q');

    [...qElem].forEach((elem) => {
        elem.addEventListener('click', function() {
            this.classList.toggle('is-open-faq')
        });
    })
}
openFaq();